'use client';
import { Transformer } from './Transformer/Transformer.js';

const AnalyticsTopic = (options)=>{
    const { bus, transforms = [] } = options;
    const transformer = Transformer(transforms);
    const analyticsTopic = {
        sendEvent
    };
    function sendEvent(eventName, payload) {
        bus.emit('event-added', eventName, transformer.reduce(eventName, payload));
    }
    return analyticsTopic;
};

export { AnalyticsTopic };
//# sourceMappingURL=AnalyticsTopic.js.map
